import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDayoffDocument } from "../../../../store/slices/applicationManagement/managementSlice";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import { DAYOFF_DOCUMENT_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { useFormik } from "formik";
import dayoffDocumentValidation from "../utils/dayoffDocumentValidation";
import {
  useFetchGetDayoffTypesQuery,
  useFetchGetDocumentTypesQuery,
  usePostDayoffTypeDocumentsMutation,
} from "../../../../store";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import CustomSelect from "../../../../components/shared/CustomSelect";
import FormHelperText from "@mui/material/FormHelperText";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Loading from "../../../../components/shared/Loading";
import Typography from "@mui/material/Typography";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";

const DayoffDocumentForm = () => {
  const dispatch = useDispatch();
  const { dayoffDocumentDialogOpen } = useSelector(
    (state) => state.dialogSlice
  );
  const { dayoffDocument } = useSelector((state) => state.managementSlice);
  const { data: dayoffTypes, isLoading: dayoffTypeLoading } =
    useFetchGetDayoffTypesQuery();
  const { data: documents, isLoading: documentLoading } =
    useFetchGetDocumentTypesQuery();
  const handleClose = () => {
    dispatch(setDayoffDocument(null));
    dispatch(closeDialog(DAYOFF_DOCUMENT_DIALOG));
  };
  const [postDayoffDocument, { isLoading }] =
    usePostDayoffTypeDocumentsMutation();
  const formik = useFormik({
    initialValues: {
      id: dayoffDocument?.id ?? 0,
      dayoffTypeId: dayoffDocument?.dayoffTypeId ?? "",
      documentTypeId: dayoffDocument?.documentTypeId ?? "",
      isRequired: dayoffDocument?.isRequired ?? false,
    },
    validationSchema: dayoffDocumentValidation,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      console.log(formik.values);
      try {
        postDayoffDocument({
          id: formik.values.id,
          dayoffTypeId: formik.values.dayoffTypeId,
          documentTypeId: formik.values.documentTypeId,
          isRequired: formik.values.isRequired,
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("Belge Kaydedildi !"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  if (dayoffTypeLoading || documentLoading)
    return <Loading isLoading={dayoffTypeLoading || documentLoading} />;
  return (
    <Modal
      open={dayoffDocumentDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          İzin Türü - Belge Eşleştir
        </Typography>
        <FormControl
          fullWidth
          sx={{ m: 1 }}
          error={
            formik.touched.documentTypeId &&
            Boolean(formik.errors.documentTypeId)
          }
        >
          <InputLabel id="documentTypeId-label">Belge Türü</InputLabel>
          <CustomSelect
            data={documents?.data}
            id="documentTypeId"
            value={formik.values.documentTypeId}
            handleChange={formik.handleChange}
          />
          {formik.touched.documentTypeId && (
            <FormHelperText>{formik.errors.documentTypeId}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          fullWidth
          sx={{ m: 1 }}
          error={
            formik.touched.dayoffTypeId && Boolean(formik.errors.dayoffTypeId)
          }
        >
          <InputLabel id="dayoffTypeId-label">İzin Türü</InputLabel>
          <CustomSelect
            data={dayoffTypes?.data}
            id="dayoffTypeId"
            value={formik.values.dayoffTypeId}
            handleChange={formik.handleChange}
          />
          {formik.touched.dayoffTypeId && (
            <FormHelperText>{formik.errors.dayoffTypeId}</FormHelperText>
          )}
        </FormControl>
        <FormGroup sx={{ m: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                value={formik.values.isRequired}
                checked={formik.values.isRequired}
                onChange={formik.handleChange}
                id="isRequired"
                name="isRequired"
                color="secondary"
              />
            }
            label="Zorunlu Belge"
          />
        </FormGroup>
        <Stack sx={{ m: 1 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DayoffDocumentForm;
